import { isNumber } from '@/helpers/is';

/**
 * transform to multiply a number by a given factor
 * @param {number} d
 * @param {object} params { by: number }
 * @returns {number}
 */
const multiplyTransform = (d, params = {}) => {
  const { by = 1 } = params;

  const numericValue = typeof d === 'string' && d.trim() !== '' ? Number(d) : d;

  if (!isNumber(numericValue) || !isNumber(by)) {
    return d;
  }

  return numericValue * by;
};

export default multiplyTransform;
